import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SerriCreateTemplateDialogComponent } from '../modules/whatsapp/whatsapp-templates/serri-create-template-dialog/serri-create-template-dialog.component';

@NgModule({
  declarations: [SerriCreateTemplateDialogComponent],
  // Do not import HttpClientModule here — JobModule is lazy-loaded and a local
  // HttpClientModule shadows AppModule's client and skips JWT interceptors.
  imports: [CommonModule, FormsModule],
  exports: [SerriCreateTemplateDialogComponent],
  entryComponents: [SerriCreateTemplateDialogComponent]
})
export class WhatsAppDialogsModule { }
